import { createSlice } from "@reduxjs/toolkit";
import { fetchFromStorage, saveToStorage } from "utils/storage";

interface AuthenticationState {
  date: any;
  openPanelAddon: any;
  initialDateForCalendar: any;
  hourlyPricing: boolean;
  cloneFromRFQ: boolean;
}

const bookingSlice = createSlice({
  name: "bookingSlice",
  initialState: {
    date: null,
    openPanelAddon: undefined,
    hourlyPricing: fetchFromStorage('hourlyPricing', true)
      ? JSON.parse(fetchFromStorage('hourlyPricing', true) as any)
      : false,
    cloneFromRFQ: fetchFromStorage('cloneFromRFQ', true)
      ? JSON.parse(fetchFromStorage('cloneFromRFQ', true) as any)
      : false,
    initialDateForCalendar: undefined// moment(new Date()).format("YYYY-MM-DD")
  },
  reducers: {
    setHourlyPricing(state, action) {
      state.hourlyPricing = action.payload;
      saveToStorage('hourlyPricing', action.payload, true);
    },
    setCloneFromRFQ(state, action) {
      state.cloneFromRFQ = action.payload;
      saveToStorage('cloneFromRFQ', action.payload, true);
    },
    setSelectedMonthBooking(state, action) {
      state.date = action.payload;
    },
    setOpenPanelAddon(state, action) {
      state.openPanelAddon = action.payload;
    },
    setInitialDate(state, action) {
      state.initialDateForCalendar = action.payload;
    },
  },
});


export default bookingSlice.reducer;
export const { setSelectedMonthBooking, setOpenPanelAddon, setInitialDate, setHourlyPricing, setCloneFromRFQ } =
  bookingSlice.actions;


export const selectedMonth = (state: { bookingSlice: AuthenticationState }) =>
  state.bookingSlice.date;

export const openPanelAddon = (state: { bookingSlice: AuthenticationState }) =>
  state.bookingSlice.openPanelAddon;

export const initialDateForCalendar = (state: { bookingSlice: AuthenticationState }) =>
  state.bookingSlice.initialDateForCalendar;

export const hourlyPricingFlag = (state: { bookingSlice: AuthenticationState }) =>
  state.bookingSlice.hourlyPricing;

export const cloneBookingFromRFQ = (state: { bookingSlice: AuthenticationState }) =>
  state.bookingSlice.cloneFromRFQ;

